import { User } from "../types";

export function UsersPictures({ sender, receiver }: { sender: User, receiver: User }) {
  function getImageUrl(user: User) {
    if (!user.image) {
      return (
        "https://ui-avatars.com/api/?name=" +
        user.firstname.replace(/[^a-zA-Z0-9]/g, "") +
        "+" +
        user.lastname.replace(/[^a-zA-Z0-9]/g, "") +
        "&background=220457&color=ffffff&font-size=0.3"
      );
    }
    return user.image;
  }
  return (
    <div className="users-pictures">
      <div className="oval-picture oval-picture-sender" style={{
        backgroundImage: "url(" + getImageUrl(sender) + ")"
      }}>
        <span className="oval-picture oval-picture-receiver" style={{
          backgroundImage: "url(" + getImageUrl(receiver) + ")"
        }}></span>
      </div>
    </div>
  )
}